import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=37a72de1&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=37a72de1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a72de1",
  null
  
)

export default component.exports